import React, { useEffect, useMemo, useState } from 'react';
import './sideFilterName.less';
import { NameFilter } from '../../interface';
import { Button, Input, Skeleton, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { updateModalSideFilters, updateSiteFilter } from '../../../../modules/SearchDatePicker/searchDatePickerSlice';
import useGetAttributeTranslation from '../../hooks/useGetAttributeTranslation';

interface Props {
  filter: NameFilter;
  withModalScopeParams?: boolean;
  isLoading?: boolean;
  additionalPrice?: number;
    localSideFilters?: Record<string, any> | null;
  setLocalSideFilters?: (f: Record<string, any>) => void;
}

const SideFilterName = ({ filter,
  withModalScopeParams,
  isLoading,
  additionalPrice = 0,
  localSideFilters,
  setLocalSideFilters
 }: Props) => {
  const dispatch = useDispatch();
  const { sideFilters: reduxSideFilters, modalSideFilters } = useSelector(
    (state: RootState) => {
      return state.search;
    }
  );
  const sideFilters = useMemo(
    () => (localSideFilters ? localSideFilters : withModalScopeParams
      ? modalSideFilters
      : reduxSideFilters),
    [withModalScopeParams, modalSideFilters, reduxSideFilters, localSideFilters]
  );
  const { general: t } = useSelector(
    (state: RootState) => state.config.translations
  );
  const [searchKeyWord, setSearchKeyWord] = useState(
    sideFilters?.[filter.attr] || ''
  );
  const attributeTranslation = useGetAttributeTranslation();

  useEffect(() => {
    if (!sideFilters?.[filter.attr]) {
      setSearchKeyWord('');
    }
  }, [sideFilters, filter.attr]);
  // helper that updates either local filters (if provided) or redux
  const commitFilter = (key: string, value: any) => {
    if (setLocalSideFilters) {
      // update local copy immutably
      setLocalSideFilters({
        ...(localSideFilters || {}),
        [key]: value,
      });
      return;
    }
    const fn = withModalScopeParams ? updateModalSideFilters : updateSiteFilter;
    dispatch(fn({ key: filter.attr, value: value }));
  };



  const handleSubmit = () => {
    commitFilter(filter.attr, searchKeyWord);
  };

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 1 }} />;
  }

  return (
    <div className="name-sidefilter">
      <h2>{attributeTranslation(filter.attr)}</h2>
      <Space.Compact>
        <Input
          onChange={(e) => setSearchKeyWord(e.target.value)}
          value={searchKeyWord}
          className="input"
          placeholder={t.search}
        />

        <Button
          type="primary"
          className="btn-style-5"
          onClick={handleSubmit}
        >
          {t.submit}
        </Button>
      </Space.Compact>
    </div>
  );
};

export default SideFilterName;
